import { snackbarQueue } from '@launchpad-ui/components';
// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import { z } from 'zod';

const errorBodySchema = z.object({ message: z.string().min(1) });

export function requestErrorNotification(message: string) {
  return async (error?: unknown) => {
    const description = `${message}: ${await getErrorMessage(error)}`;
    return snackbarQueue.add({ description, status: 'error' });
  };
}

async function getErrorMessage(error?: unknown): Promise<string> {
  if (error instanceof Error) {
    return error.message || 'unknown error';
  }

  if (error instanceof Response) {
    if (error.status === 500) {
      return 'internal server error';
    }
    const body = await tryParseResponseJson(error);
    const parsed = errorBodySchema.safeParse(body);
    if (parsed.success) {
      return parsed.data.message;
    }
    return error.statusText || 'unknown error';
  }

  return 'unknown error';
}

async function tryParseResponseJson(response: Response): Promise<unknown> {
  try {
    return await response.clone().json();
  } catch {
    return undefined;
  }
}
